import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UserService } from '@app/user';

@Component({
    selector: 'app-profile-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProfileAvatarComponent {
    @Input({ required: true })
    size: 'xs' | 'sm' | '2md' | 'md' | 'lg' | 'xl';

    constructor(private userService: UserService) {}

    get initials(): string {
        return this.userService.user.firstname.charAt(0) + this.userService.user.surname.charAt(0);
    }
}
